import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Observable, Subject, Subscription, of } from 'rxjs';
import * as moment from 'moment';
import { DatePickerConfig, DateRangeSettings } from './date-config-interface';

@Component({
  selector: 'app-filter-date-range',
  templateUrl: './filter-date-range.component.html',
  styleUrls: ['./filter-date-range.component.scss']
})
export class FilterDateRangeComponent implements OnInit, OnChanges {
  @Output() rangeChanged: EventEmitter<any> = new EventEmitter<any>();
  @Input() rangeConfig: DateRangeSettings;
  @Input() opens = 'right';
  @Input() skewed = false;
  // The picker directive reads timePicker/locale when it is created, so a new
  // settings object (a report that wants dates without times, or the reverse)
  // re-creates it instead of mutating it in place.
  pickerReady = true;

  constructor( ) { }

  ngOnInit() {
    if ( !this.rangeConfig ) {
      this.rangeConfig = new DateRangeSettings();
    }
    this.setDateConfig(this.rangeConfig);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.rangeConfig && !changes.rangeConfig.firstChange) {
      this.setDateConfig(this.rangeConfig);
      this.pickerReady = false;
      setTimeout(() => { this.pickerReady = true; }, 0);
    }
  }

  // Box text: date + time ('lll', e.g. "Nov 3, 2026 12:00 AM") when the time
  // picker is on — the library's own default — and the date alone ('ll',
  // "Nov 3, 2026") when it is off.
  get locale() {
    return { format: this.rangeConfig?.dateConfig?.includeTime === false ? 'll' : 'lll' };
  }

  datesUpdated(range) {
    if (range && (range.startDate || range.endDate)) {
      this.rangeChanged.emit( range );
    }
  }

  setDateConfig(dateConfigInput: DateRangeSettings) {
    if ( !this.rangeConfig ) {
      this.rangeConfig = new DateRangeSettings();
    }

    if (dateConfigInput) {
      if (dateConfigInput.dateConfig.singleDate) {
        this.rangeConfig.dateRange.endDate = this.rangeConfig.dateRange.startDate;
      }
      for (const configKey of Object.keys(this.rangeConfig.dateConfig)) {
        if (dateConfigInput.dateConfig[configKey] !== undefined) {
          this.rangeConfig.dateConfig[configKey] = dateConfigInput.dateConfig[configKey];
        }
      }
    }
  }
}
